import script from "./TokenDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenDetail.vue?vue&type=script&setup=true&lang=ts"

import "./TokenDetail.vue?vue&type=style&index=0&id=264327f4&lang=scss"

const __exports__ = script;

export default __exports__